import _ from 'lodash';
import CHATED from '../../../helpers/chated-client';

import {
	SEND_PAYMENT,
	ERROR_SEND_PAYMENT,
	GET_PRODUCTS,
	ERROR_PRODUCTS,

	RESET_ALERT_MESSAGE,
	RESET
} from '../../../constants';

export function resetAlertMessage() {
	return async (dispatch) => {
		dispatch({
			type: RESET_ALERT_MESSAGE
		});
	};
}

export function reset() {
	return async (dispatch) => {
		dispatch({
			type: RESET
		});
	};
}

export function getPaymentPlans() {
	return async (dispatch) => {
		const response = await CHATED.product.getAll({
			product_slug: 'email_plus'
		});

		if (response.meta.code !== 200) {
			dispatch({
				type: ERROR_PRODUCTS,
				meta: response.meta
			});

			return;
		}

		const product = response.data.products[0];

		if (!_.isNil(product)) {
			dispatch({
				type: GET_PRODUCTS,
				meta: null,
				paymentPlans: product.variants
			});
		}
	};
}

export function sendPayment(appConnection, chosenPlan, returnUrl) {
	return async (dispatch) => {
		const response = await CHATED.payment.sendPayment({
			payment: {
				app_connection_id: appConnection._id,
				product_slug: 'email_plus',
				product_variant_slug: chosenPlan,
				payment_method: 'shopify_application_charge'
			},
			return_url: returnUrl
		});

		console.log('response = ', response);
		if (response.meta.code !== 200) {
			dispatch({
				type: ERROR_SEND_PAYMENT,
				meta: response.meta
			});
			return;
		}

		const payment = response.data.payment;

		dispatch({
			type: SEND_PAYMENT,
			meta: null,
			confirmationUrl: payment.data.confirmation_url
		});
	};
}



// WEBPACK FOOTER //
// ./src/containers/email-plus-page/actions/index.js